export const GoAngledView = "https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/GoAngledView.png"

export const GoFrontView = "https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/GoFrontView.png"

export const GoSideView = "https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/GoSideView.png"

export const GoTopViewGraphic = "https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/GoTopViewGraphic.png"


// WEBPACK FOOTER //
// ./src/images/LandingPageNYC/NYCImageLinks.js